<template>
  <div class="gd-navbar">
    <div class="gd-pull-right-layout">
        <div class="gd-pull-right-layout__first-elmt">
            <router-link :to="{ name: 'Home' }" class="gd-navbar__logo">
              GUI Drivers
            </router-link>
        </div>
        <div class="gd-pull-right-layout__second-elmt">
            <IconDisconnect class="gd-navbar__icon" @click.native="disconnect()"></IconDisconnect>
        </div>
    </div>
  </div>
</template>

<script>
import IconDisconnect from '@/assets/svg/icon-disconnect.svg';
import auth from '@/utils/auth';

export default {
  name: 'navbar',

  components: {
    IconDisconnect,
  },

  methods: {
    disconnect() {
      auth.logout();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue